var _defs, _style, _use, _use2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 50",
    width: 90,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 50,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAyAQMAAADmwV52AAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAA9JREFUeJxjYBgFo2AwAAACigABxXWI+QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 114,
    height: 72,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiBpY29uLS1mdWxsLWNvbG9yIiB2aWV3Qm94PSIwIDAgMzggMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgaGVpZ2h0PSIyNCIgd2lkdGg9IjM4IiByb2xlPSJpbWciIGFyaWEtbGFiZWxsZWRieT0icGktZnJlZWNoYXJnZSI+PHRpdGxlIGlkPSJwaS1mcmVlY2hhcmdlIj5GcmVlY2hhcmdlPC90aXRsZT48ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9Im5vbmUiPjxwYXRoIGQ9Ik0zNC41IDI0aC0zMUMxLjYgMjQgMCAyMi40IDAgMjAuNXYtMTdDMCAxLjYgMS42IDAgMy41IDBoMzFDMzYuNCAwIDM4IDEuNiAzOCAzLjV2MTdjMCAxLjktMS42IDMuNS0zLjUgMy41eiIvPjxwYXRoIGQ9Ik0zLjUgMUMyLjEgMSAxIDIuMSAxIDMuNXYxN0MxIDIxLjkgMi4xIDIzIDMuNSAyM2gzMWMxLjQgMCAyLjUtMS4xIDIuNS0yLjV2LTE3QzM3IDIuMSAzNS45IDEgMzQuNSAxaC0zMXoiLz48Y2lyY2xlIGN5PSIxMiIgY3g9IjE5IiByPSI5IiBmaWxsPSIjRTI3MDREIi8+PHBhdGggZmlsbD0iI2ZhZmFmYSIgZD0iTTE2LjYgMTEuN2wuMS0xLjRzLjcuMS45LS4xYy40LS4zLjQtLjkuNS0xLjIuMy0xLjQgMi0yLjIgMy44LTEuN2wtLjIgMS40cy0uMS0uMS0uNC0uMWMtMS4xLS4xLTEuNi4yLTEuNyAxLjdoMS41bC0uMiAxLTIuNCAyLjRoMS40Yy0xLjIgMS4zLTIuOCAyLjktMy44IDMuOGwxLjMtMi42aC0xLjFjMS0xLjkgMS0yIDEuNy0zLjMiLz48L2c+PC9zdmc+"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#img2",
    transform: "matrix(.635,0,0,.635,8.758,1.13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreecharge);
export default __webpack_public_path__ + "static/media/freecharge.5f20fd424391d2d57073d305a913d38e.svg";
export { ForwardRef as ReactComponent };